import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import store from './store';
import { PermissionProvider } from './context/PermissionProvider';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <PermissionProvider>
            <App />
          </PermissionProvider>
        </BrowserRouter>
      </QueryClientProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </React.Fragment>
  </Provider>,
);

serviceWorker.unregister();
